import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <div className={styles.code}>404</div>
        <h1>Strona nie istnieje</h1>
        <p>Adres który wpisałeś/aś nie istnieje lub ogłoszenie zostało usunięte.</p>
        <div className={styles.actions}>
          <button className={styles.back} onClick={() => navigate(-1)}>← Wróć</button>
          <Link to="/" className={styles.home}>Strona główna</Link>
          <Link to="/ogloszenia" className={styles.browse}>Przeglądaj ogłoszenia</Link>
        </div>
      </div>
    </div>
  );
}
